import { render, staticRenderFns } from "./rating-quarternary.vue?vue&type=template&id=4bd2776e&scoped=true&"
import script from "./rating-quarternary.vue?vue&type=script&lang=js&"
export * from "./rating-quarternary.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bd2776e",
  null
  
)

export default component.exports